import React, { useState, useEffect } from 'react';
import { Paper, Typography, Box, TextField, Button, Tooltip, Snackbar } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LaunchIcon from '@mui/icons-material/Launch';

import { t } from '../i18n/useTranslation';

  const isStaging = window.location.hostname.includes('staging');
  const isLocal = window.location.hostname.includes('localhost');

  const CONFIGURATOR_BASE_URL = isLocal 
    ? "http://127.0.0.1:5501" 
    : isStaging
      ? "https://staging--configurator101.netlify.app" 
      : "https://configurator.alfresko.co.uk";
      
const MarketingWidget = ({ lang }) => {
  const [marketingLink, setMarketingLink] = useState('');
  const [toastOpen, setToastOpen] = useState(false);



  const getDealerIdFromToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) return null;

    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      const decoded = JSON.parse(jsonPayload);
      return decoded.DealerId; 
    } catch (error) {
      console.error("Failed to decode token:", error);
      return null;
    }
  };

  useEffect(() => {
      let id = getDealerIdFromToken();

      if (!id) {
          console.warn("MarketingWidget: No DealerId found in token. Using Demo ID.");
          id = "d1b5a5b5-89e4-4c7b-8a2e-0a5d6e3c4a2a"; 
      }

      //const lang = localStorage.getItem('dealerLanguage') || 'en';
      const langParam = lang !== 'en' ? `&lang=${lang}` : '';
      setMarketingLink(`${CONFIGURATOR_BASE_URL}?dealerId=${id}${langParam}`);
  }, [lang]);

  const handleCopy = () => {
    navigator.clipboard.writeText(marketingLink);
    setToastOpen(true);
  };

  const handleOpen = () => {
    window.open(marketingLink, '_blank');
  };

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 3, 
        mb: 4, 
        borderLeft: '6px solid #a8851d',
        background: 'linear-gradient(to right, #fff, #fcfaf5)' 
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ color: '#1a1a1a', fontWeight: 'bold' }}>
          {t('marketing.title')}
        </Typography>
        <Typography variant="body2" sx={{ color: '#666' }}>
          {t('marketing.subtitle')}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <TextField 
          fullWidth 
          variant="outlined" 
          size="small" 
          value={marketingLink} 
          InputProps={{
            readOnly: true,
            style: { color: '#555', backgroundColor: '#f5f5f5' }
          }}
        />
        
        <Tooltip title="Copy to Clipboard">
          <Button 
            variant="contained" 
            sx={{ bgcolor: '#a8851d', '&:hover': { bgcolor: '#8c6e18' }, minWidth: '50px' }}
            onClick={handleCopy}
          >
            <ContentCopyIcon />
          </Button>
        </Tooltip>

        <Tooltip title="Test Link">
          <Button 
            variant="outlined" 
            sx={{ color: '#a8851d', borderColor: '#a8851d' }}
            onClick={handleOpen}
          >
            <LaunchIcon />
          </Button>
        </Tooltip>
      </Box>

      <Snackbar 
        open={toastOpen} 
        autoHideDuration={2000} 
        onClose={() => setToastOpen(false)}
        message={t('marketing.copied')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
      </Snackbar>
    </Paper>
  );
};

export default MarketingWidget;